import { render, staticRenderFns } from "./scene1Mobile.vue?vue&type=template&id=86858a34&scoped=true&"
import script from "./scene1Mobile.vue?vue&type=script&lang=js&"
export * from "./scene1Mobile.vue?vue&type=script&lang=js&"
import style0 from "./scene1Mobile.vue?vue&type=style&index=0&id=86858a34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86858a34",
  null
  
)

export default component.exports